import React from "react";
import {ActionRow, Card, DescriptionCardHeading} from "peggirkit";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {useIntl} from "react-intl";
import {CartInTimeline, CartKindFilter} from "@widgets/reports/cartTimeline/CartTimelineUtils";
import CartTimelineChart from "@widgets/reports/cartTimeline/timeline/CartTimelineChart";
import CartKindFilterButton from "@widgets/reports/cartTimeline/timeline/CartKindFilterButton";

type Props = {
    carts: CartInTimeline[],
    allCarts: CartInTimeline[],
    day: Date,
    now: Date | null,
    filter: CartKindFilter,
    setFilter: (filter: CartKindFilter) => void,
    showPos: boolean,
    setShowPos: (show: boolean) => void,
    counts: Record<CartKindFilter, number>,
    onSelect: (item: CartInTimeline) => void,
};

const CartTimelineCard = ({
                              carts,
                              allCarts,
                              day,
                              now,
                              filter,
                              setFilter,
                              showPos,
                              setShowPos,
                              counts,
                              onSelect,
                          }: Props) => {
    const intl = useIntl();

    return (
        <Card
            header={
                <CardHeader
                    actionRow={
                        <ActionRow useMoreButton={false}>
                            <CartKindFilterButton
                                filter={filter}
                                setFilter={setFilter}
                                showPos={showPos}
                                setShowPos={setShowPos}
                                counts={counts}
                            />
                        </ActionRow>
                    }
                >
                    <DescriptionCardHeading
                        title={intl.formatMessage({id: "cartTimeline.timeline"})}
                        description={intl.formatMessage({id: "cartTimeline.timeline.description"})}
                    />
                </CardHeader>
            }
        >
            <CartTimelineChart
                carts={carts}
                allCarts={allCarts}
                day={day}
                now={now}
                onSelect={onSelect}
            />
        </Card>
    );
};

export default CartTimelineCard;